export default function render({
    text,
    questionId,
    questionOptionId,
    parentOptionId,
    parentText,
}) {
  return `<li data-section-question-option-id="${questionOptionId}" 
              ${parentOptionId ? `data-parent-option-id="${parentOptionId}" class="nhs-c-input__wrapper" hidden` : `class="nhs-c-input__container--with-text-16"`}>
              ${parentOptionId
                  ? `<label class="nhs-c-input__label nhs-c-label--black-1000-body-small-regular">${text}</label>
                      <input type="text" 
                        class="nhs-c-input__field nhs-u-flex--1-0-auto" 
                        id="${questionOptionId}"
                        name="${questionId}" 
                        data-parent-text="${parentText}"
                        data-question-text="${text}" 
                        data-question-id="${questionId}" value="" />
                      <span data-error-label class="nhs-c-input__label--error">Please enter a value</span>` 
                  : `<input class="nhs-c-input__radio" 
                      value="${questionOptionId}" 
                      data-parent-text="${parentText}" 
                      data-question-text="${text}" 
                      data-question-id="${questionId}" 
                      id="${questionOptionId}" type="radio" name="${questionId}" /> 
                      <label class="nhs-c-label--black-1000-body-1-medium-regular" 
                        for="${questionOptionId}">${text}</label>`}                
          </li>`;
}